import { StatusFormatterVariant } from '@components'

import { VatDeclarationStatus } from '../../../enums/vatDeclarationStatus'

export const vatDeclarationStatusToStatusVariant: Record<
  VatDeclarationStatus,
  StatusFormatterVariant | [StatusFormatterVariant, StatusFormatterVariant]
> = {
  [VatDeclarationStatus.Draft]: 'primary',
  [VatDeclarationStatus.OverduePayment]: 'error',
  [VatDeclarationStatus.OverdueSubmission]: 'error',
  [VatDeclarationStatus.Paid]: 'success',
  [VatDeclarationStatus.Pending]: 'primary',
  [VatDeclarationStatus.ReadyToPay]: 'warning',
  [VatDeclarationStatus.ReadyToSubmit]: 'warning',
  [VatDeclarationStatus.SubmissionFailed]: 'error',
}
